module.exports = __webpack_public_path__ + "img/404.bd8b0af5f7a5bdf3fa90ffb0ba754f7e.png";